"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _misc = _interopRequireDefault(require("../../helpers/misc"));
var _jsonrpc = require("../jsonrpc");
var _ethereumjsUtil = _interopRequireDefault(require("ethereumjs-util"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable */
var _default = async (_ref, res, next) => {
  let payload = _ref.payload;
  if (payload.method !== 'personal_ecRecover') return next();
  if (payload.params.length < 2) {
    res((0, _jsonrpc.toError)(payload.id, `personal_ecRecover expects 2 parameters.  Received ${payload.params.length} `));
  }
  const parts = _ethereumjsUtil.default.fromRpcSig(payload.params[1]);
  if (!parts) {
    res((0, _jsonrpc.toError)(payload.id, 'Invalid signature supplied to personal_ecRecover'));
  }
  const recovered = _ethereumjsUtil.default.ecrecover(_ethereumjsUtil.default.hashPersonalMessage(_misc.default.toBuffer(payload.params[0])), parts.v, parts.r, parts.s);
  const addressBuffer = _ethereumjsUtil.default.pubToAddress(recovered);
  res(null, (0, _jsonrpc.toPayload)(payload.id, '0x' + addressBuffer.toString('hex')));
};
exports.default = _default;